import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './Navbar.css';
import logo from '../assets/logo.svg';

const Navbar = () => {
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(i18n.language.toUpperCase());

  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  const selectLanguage = (lang) => {
    const newLang = lang.toLowerCase();
    i18n.changeLanguage(newLang);
    setDropdownOpen(false);

    const params = new URLSearchParams(window.location.search);
    params.set('lang', newLang);
    const newUrl = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
    window.history.replaceState({}, '', newUrl);
  };

  useEffect(() => {
    setSelectedLanguage(i18n.language.toUpperCase());
  }, [i18n.language]);

  // Smooth-scroll on home; otherwise navigate to home with ?lang + #hash
  const handleAnchor = (e, id) => {
    e.preventDefault();
    const onHome =
      window.location.pathname === '/' ||
      window.location.pathname === '/index.html';

    if (onHome) {
      const el = document.getElementById(id);
      if (el) {
        const url = `${window.location.pathname}${window.location.search}#${id}`;
        window.history.replaceState({}, '', url);
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      const params = new URLSearchParams(window.location.search);
      if (!params.get('lang')) params.set('lang', i18n.language);
      const query = params.toString();
      const target = `/${query ? `?${query}` : ''}#${id}`;
      window.location.assign(target);
    }
  };

  // Navigate to /giftvoucher while preserving ?lang
  const handleGiftClick = (e) => {
    e.preventDefault();
    const params = new URLSearchParams(window.location.search);
    if (!params.get('lang')) params.set('lang', i18n.language);
    const query = params.toString();
    const target = `/giftvoucher${query ? `?${query}` : ''}`;
    window.location.assign(target);
  };

  // Honor deep links like /?lang=eng#contact after i18n renders
  useEffect(() => {
    const id = window.location.hash?.slice(1);
    if (!id) return;
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 0);
  }, [i18n.language]);

  return (
    <nav className="navbar navbar-expand-lg navbar-light">
      <div className="container-fluid px-0 px-md-3">
        <a className="navbar-brand d-flex align-items-center" href="/">
          <img src={logo} alt="Logo" className="me-2" />
          <div>
            <span className="tagline-name">Ondřej Štaidl</span><br />
            <span className="tagline-title">{t('navbar.instructor')}</span>
          </div>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse justify-content-end text-end" id="navbarNav">
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <a
                className="nav-link"
                href="#services"
                onClick={(e) => handleAnchor(e, 'services')}
              >
                {t('navbar.services')}
              </a>
            </li>

            <li className="nav-item">
              <a
                className="nav-link"
                href="#contact"
                onClick={(e) => handleAnchor(e, 'contact')}
              >
                {t('navbar.contact')}
              </a>
            </li>

                        {/* Gift voucher */}
            <li className="nav-item">
              <a
                className="nav-link nav-link-gift"
                href="/giftvoucher"
                onClick={handleGiftClick}
              >
                {t('navbar.giftVoucher')}
              </a>
            </li>

            {/* DESKTOP: dropdown language selector */}
            <li className="nav-item dropdown nav-lang-dropdown">
              <a
                className="nav-link dropdown-toggle"
                href="#!"
                id="navbarDropdown"
                role="button"
                onClick={toggleDropdown}
              >
                {selectedLanguage}
              </a>
              <ul
                className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`}
                aria-labelledby="navbarDropdown"
              >
                <li><a className="dropdown-item" href="#en" onClick={() => selectLanguage('ENG')}>ENG</a></li>
                <li><a className="dropdown-item" href="#cz" onClick={() => selectLanguage('CZ')}>CZ</a></li>
                <li><a className="dropdown-item" href="#de" onClick={() => selectLanguage('DE')}>DE</a></li>
              </ul>
            </li>

            {/* MOBILE: inline language links */}
            <li className="nav-item nav-lang-inline">
              {['ENG', 'CZ', 'DE'].map((code) => (
                <button
                  key={code}
                  type="button"
                  className={`nav-lang-link ${
                    selectedLanguage === code ? 'active' : ''
                  }`}
                  onClick={() => selectLanguage(code)}
                >
                  {code}
                </button>
              ))}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
